"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCandid = exports.fromCandid = void 0;
const principal_1 = require("@dfinity/principal");
function fromCandid(value) {
    return value.toString();
}
exports.fromCandid = fromCandid;
function toCandid(userId) {
    return principal_1.Principal.fromText(userId);
}
exports.toCandid = toCandid;
